import React from 'react';

import { InputProps, TextField } from '@material-ui/core';

import { FadeInComponent } from '@/components/FadeInComponent';
import useDebouncedInputChange from '@/core/users/UserInvite/useDebouncedInputChange';
import { ReactComponent as WarningIcon } from '@/icons/warning.svg';

type Props = {
  email: string;
  onChange: InputProps['onChange'];
  errorMessage?: string;
}
export function CustomReplyToField ({ email, onChange, errorMessage }: Props) {
  const [value, onInputChange] = useDebouncedInputChange(onChange, email);

  return (
    <FadeInComponent className="ml-4">
      <TextField
        label="Custom email"
        placeholder="Enter email address"
        variant="outlined"
        className="w-96"
        value={value}
        error={!!errorMessage}
        onChange={onInputChange}
      />
      {errorMessage && (
        <FadeInComponent key={errorMessage} className="absolute mt-3">
          <div className="flex items-center py-3 pl-5 pr-8 text-sm rounded bg-salmon-100 text-error">
            <WarningIcon className="w-4 h-4 mr-3" />
            {errorMessage}
          </div>
        </FadeInComponent>
      )}
    </FadeInComponent>
  );
}
